import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/category -> bare array of active, non-deleted categories.
export default function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    client
      .get('/category')
      .then(({ data }) => {
        if (!active) return;
        setCategories(Array.isArray(data) ? data : []);
        setError(null);
      })
      .catch((err) => {
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { categories, loading, error };
}
